import { ArrowForwardIos, ContentCopy, Delete, LocalHospital } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

const COLOR = "#065f46";
const BG = "#d1fae5";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);
  const cfg = data?.data || data;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "280px",
        maxWidth: "280px",
        width: "280px",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: `2px solid ${isHovered ? COLOR : "#e5e7eb"}`,
        boxShadow: isHovered
          ? `0 12px 32px rgba(6,95,70,.14), 0 0 0 1px rgba(6,95,70,.08)`
          : "0 4px 16px rgba(0,0,0,.06)",
        transition: "all 0.2s ease",
        transform: isHovered ? "translateY(-2px)" : "translateY(0)",
        userSelect: "none",
      }}
    >
      {/* Target */}
      <Handle
        type="target"
        position="left"
        style={{
          background: COLOR, width: 16, height: 16, left: -10,
          border: "3px solid #fff", boxShadow: `0 2px 8px rgba(6,95,70,.3)`,
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos sx={{ color: "#fff", width: 8, height: 8, ml: "2.5px", mb: "0.5px", pointerEvents: "none" }} />
      </Handle>

      {/* Actions */}
      <div style={{ position: "absolute", right: 16, top: 16, display: "flex", gap: 8, opacity: isHovered ? 1 : 0, transition: "opacity .2s" }}>
        <div onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
          style={{ width: 28, height: 28, borderRadius: 8, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <ContentCopy sx={{ width: 14, height: 14, color: "#6b7280" }} />
        </div>
        <div onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
          style={{ width: 28, height: 28, borderRadius: 8, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <Delete sx={{ width: 14, height: 14, color: "#ef4444" }} />
        </div>
      </div>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #f3f4f6" }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${COLOR}, #047857)`, display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, boxShadow: `0 4px 12px rgba(6,95,70,.25)`, flexShrink: 0 }}>
          <LocalHospital sx={{ width: 18, height: 18, color: "#fff" }} />
        </div>
        <div>
          <div style={{ color: "#111827", fontSize: 16, fontWeight: 700 }}>Sys Clínica — Menu</div>
          <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 500 }}>Agendamentos · Treinos · Faturas</div>
        </div>
      </div>

      {/* Body */}
      <div style={{ background: BG, padding: 12, borderRadius: 10, border: `1px solid #6ee7b7`, marginBottom: 16 }}>
        <div style={{ fontSize: 11, color: "#064e3b", fontWeight: 600, marginBottom: 4 }}>Solicita CPF se não cadastrado</div>
        <div style={{ fontSize: 12, color: COLOR }}>
          {cfg?.msgMenu
            ? cfg.msgMenu.slice(0, 60) + (cfg.msgMenu.length > 60 ? "…" : "")
            : "Envia menu interativo ao paciente"}
        </div>
      </div>

      {/* Handles de saída */}
      {[
        { id: "agendamentos", label: "Agendamentos", color: "#0369a1", top: "35%" },
        { id: "treinos",      label: "Treinos",      color: "#7c3aed", top: "52%" },
        { id: "faturas",      label: "Faturas",      color: "#b91c1c", top: "69%" },
        { id: "erro",         label: "Erro",         color: "#ef4444", top: "86%" },
      ].map(h => (
        <React.Fragment key={h.id}>
          <Handle type="source" position="right" id={h.id}
            style={{ background: h.color, width: 16, height: 16, right: -10, top: h.top, border: "3px solid #fff" }}
            isConnectable={isConnectable}>
            <ArrowForwardIos sx={{ color: "#fff", width: 8, height: 8, ml: "2px", mb: "0.5px", pointerEvents: "none" }} />
          </Handle>
          <div style={{ position: "absolute", right: 20, top: `calc(${h.top} - 8px)`, fontSize: 10, fontWeight: 700, color: h.color, whiteSpace: "nowrap" }}>
            {h.label}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
});
